
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IPolicyTemplate, IStepTree, ITextInfo, IPrograms, ISaveProject, IFiles } from './types/StepTree-interface'

const StepTreeState = (state: RootState): IStepTree => state.StepTreeCancer

export const FormFieldsStepTree = createSelector(
    [StepTreeState],
    (state): IStepTree => state,
)
export const policyTemplate = createSelector(
    [StepTreeState],
    (state): IPolicyTemplate => state.PolicyTemplate,
)
export const textInfo = createSelector(
    [StepTreeState],
    (state): ITextInfo => state.TextInfo,
)
export const programs = createSelector(
    [StepTreeState],
    (state): IPrograms => state.Programs,
)

export const saveProjectState = createSelector(
    [StepTreeState],
    (state): ISaveProject => state.SaveProject,
)

export const files = createSelector(
    [StepTreeState],
    (state): IFiles => state.Files,
)